import React, { FunctionComponent } from "react";

const ConversationChatIcon: FunctionComponent = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
    >
      <path
        d="M7.97064 1.63904V5.6684H2.31227L1.63879 6.34187V1.63904H7.97064ZM8.54626 0.487793H1.06317C0.746579 0.487793 0.487549 0.746823 0.487549 1.06342V9.12213L2.79004 6.81964H8.54626C8.86286 6.81964 9.12189 6.56061 9.12189 6.24402V1.06342C9.12189 0.746823 8.86286 0.487793 8.54626 0.487793ZM11.4244 2.79028H10.2731V7.97089H2.79004V9.12213C2.79004 9.43872 3.04907 9.69775 3.36566 9.69775H9.69751L12 12.0002V3.36591C12 3.04931 11.741 2.79028 11.4244 2.79028Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ConversationChatIcon;
